<template>
    <div 
        id="scheduled_contact_deletions" 
        class="col-12">
        <form @submit.prevent="search">
            <div 
                id="search-filters" 
                class="box box-primary">
                <div class="box-header with-border filters-header">
                    <h3 class="box-title"><i 
                        class="fa fa-search" 
                        aria-hidden="true"/> Filtri / iskanje</h3>
                </div>
                <div class="box-body row">
                    <div class="col-md-3">
                        <div class="form-group filter-input">
                            <label for="email">E-pošta</label>
                            <input 
                                id="email" 
                                v-model="moreParams.email"
                                class="form-control" 
                                type="text"
                                placeholder="E-pošta">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group filter-input">
                            <label for="phone">Telefon</label>
                            <input 
                                id="phone" 
                                v-model="moreParams.phone"
                                class="form-control" 
                                type="text"
                                placeholder="Telefon">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group filter-input">
                            <label for="name">Ime</label>
                            <input 
                                id="name" 
                                v-model="moreParams.name"
                                class="form-control" 
                                type="text"
                                placeholder="Ime">
                        </div>
                    </div>
                    <div class="col-md-3">
                        <label for="source_id">Vir</label>
                        <multiselect 
                            id="source_id"
                            v-model="selectedSource"
                            :options="sources"
                            :custom-label="multiselectLabel"
                            :close-on-select="true"
                            selected-label="Izbrano"
                            select-label=""
                            deselect-label="Odstrani"
                            placeholder="Izberi"
                            track-by="id"
                            label="name"
                            @input="setSelectedSourceId"/>
                    </div>
                </div>
                <div class="box-footer">
                    <button 
                        class="btn btn-md btn-primary" 
                        type="submit">Išči</button>
                    <button 
                        class="btn btn-md btn-danger"
                        @click.prevent="resetSearch">
                        Ponastavi
                    </button>
                </div>
            </div>
        </form>
        <div class="box box-success">
            <div class="box-header">
                <h3 class="box-title">Seznam kontaktov, ki čakajo na izbris</h3>
            </div>
            <div 
                :class="isLoading ? 'loading' : ''" 
                class="box-body table-responsive no-padding">
                <div class="loader">
                    <img 
                        src="/images/spinner.svg" 
                        alt="Nalagam" 
                        width="200" 
                        height="200">
                    <b>NALAGAM</b>
                </div>
                <vuetable 
                    id="contacts-main-table"
                    ref="vuetable"
                    :api-url="api_route"
                    :fields="fields"
                    :css="css.table"
                    :row-class="rowClass"
                    :initial-page="initialPage"
                    :per-page="perPage"
                    :sort-order="sortOrder"
                    :multi-sort="true"
                    :append-params="moreParams"
                    pagination-path="meta"
                    detail-row-component="scheduled-deletions-contact-versions"
                    @vuetable:loaded="dataLoaded"
                    @vuetable:cell-clicked="onCellClicked"
                    @vuetable:pagination-data="onPaginationData"/>
            </div>
            <div class="box-footer clearfix">
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-left">
                    <p>Zadetkov na stran</p>
                    <select 
                        v-model="perPage"
                        @change="changePerPage">
                        <option 
                            v-for="option in perPageOptions"
                            :key="option"
                            :value="option">
                            {{ option }} / stran
                        </option>
                    </select>
                </div>
                <div class="vuetable-pagination pagination pagination-sm no-margin pull-right">
                    <vuetable-pagination-info
                        ref="paginationInfo"
                        info-template="Prikazujem {from} do {to} od {total} zapisov"
                        info-class="pagination-info"/>
                    <vuetable-pagination-dropdown
                        ref="pagination"
                        :css="css.dropdownPagination"
                        page-text="stran"
                        @vuetable-pagination:change-page="onChangePage"/>
                </div>
            </div>
        </div>
        <new-contact :api_route="api_route"/>
    </div>
</template>

<script>
import Vuetable                          from 'vuetable-2/src/components/Vuetable';
import VuetablePagination                from 'vuetable-2/src/components/VuetablePagination';
import VuetablePaginationDropdown        from '../VuetablePaginationDropdownWithFirstAndLast';
import VuetablePaginationInfo            from 'vuetable-2/src/components/VuetablePaginationInfo';
import TablePagination                   from '../../mixins/TablePagination';
import Table                             from '../../mixins/Table';
import DeleteAction                      from './../DeleteAction';
import TableUrlParams                    from '../../mixins/TableUrlParams';
import ApiRoutes                         from '../../mixins/ApiRoutes';
import VuejsDialog                       from 'vuejs-dialog';
import ScheduledDeletionsContactVersions from './Components/ScheduledDeletionsContactVersions';
import ContactsCommon                    from '../../mixins/Contacts';
import Multiselect                       from 'vue-multiselect';

Vue.component('delete-action', DeleteAction);
Vue.component('scheduled-deletions-contact-versions', ScheduledDeletionsContactVersions);
Vue.use(VuejsDialog);

export default {
    name: 'ScheduledDeletions',

    components: {
        Vuetable,
        VuetablePagination,
        VuetablePaginationDropdown,
        VuetablePaginationInfo,
        Multiselect
    },

    mixins: [
        ApiRoutes,
        Table,
        TableUrlParams,
        TablePagination,
        ContactsCommon
    ],

    data() {
        return {
            sources:                  [],
            selectedSource:           null,
            fields:                   [
                {
                    name:      'id',
                    title:     '#',
                    sortField: 'id',
                },
                {
                    name:      'created_at',
                    title:     'čaka od',
                    callback:  value => this.$options.filters.formatDate(value.date, 'DD.MM.YYYY HH:mm:ss'),
                    sortField: 'created_at'
                },
                {
                    name:      'email',
                    title:     'e-pošta',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'email'
                },
                {
                    name:      'phone',
                    title:     'telefon',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'phone'
                },
                {
                    name:      'mobile_phone',
                    title:     'GSM',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'mobile_phone'
                },
                {
                    name:      'tax_id',
                    title:     'davčna',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'tax_id'
                },
                {
                    name:      'name',
                    title:     'ime',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'name'
                },
                {
                    name:      'sex',
                    title:     'spol',
                    callback:  value => {
                        switch (value) {
                        case 'male':
                            return '<span class="label label-primary">moški</span>';
                        case 'female':
                            return '<span class="label label-danger">ženska</span>';
                        case 'neutral':
                        default:
                            return '<span class="label label-warning">nedoločen</span>';
                        }
                    },
                    sortField: 'sex'
                },
                {
                    name:      'birthday',
                    title:     'roj.',
                    callback:  value => this.$options.filters.formatDate(value, 'YYYY'),
                    sortField: 'birthday'
                },
                {
                    name:      'address',
                    title:     'naslov',
                    callback:  value => value ? value : 'n/a',
                    sortField: 'address'
                },
                {
                    name:      'post',
                    title:     'pošta',
                    callback:  value => value ? `${value.id} ${value.name}` : 'n/a',
                    sortField: 'post'
                },
                {
                    name:      'municipality',
                    title:     'občina',
                    callback:  value => value ? value.name : 'n/a',
                    sortField: 'municipality'
                },
                {
                    name:      'region',
                    title:     'regija',
                    callback:  value => value ? value.name : 'n/a',
                    sortField: 'region'
                },
                {
                    name:       '__component:delete-action',
                    title:      'anonimiziraj',
                    titleClass: 'text-center',
                    dataClass:  'text-center status category-status'
                }
            ],

            perPage: 12,

            css: {
                table: {
                    tableClass: 'table table-striped table-hover'
                }
            },

            filterBy: ['id',
                'email',
                'phone',
                'name',
                'source_id',
                'with_trashed'],

            sortOrder: [{
                field:     'created_at',
                sortField: 'created_at',
                direction: 'asc'
            }],
        };
    },

    created() {
        this.getSources();
    },

    methods: {
        search() {
            Vue.nextTick(() => this.$refs.vuetable.refresh());

            this.dataLoading();
        },

        resetSearch() {
            this.$set(this.moreParams, 'email', null);
            this.$set(this.moreParams, 'phone', null);
            this.$set(this.moreParams, 'name', null);
            this.$set(this.moreParams, 'source_id', null);
            this.$set(this.moreParams, 'with_trashed', null);

            this.search();
        },

        multiselectLabel(option) {
            return option.name;
        },

        getSources() {
            axios.get('/ajax/sources', {
                params: {
                    no_paginate: 1,
                    sort:        'name|asc'
                }
            })
                .then(response => {
                    this.$set(this, 'sources', response.data.data);
                })
                .catch(error => {
                    if ('errors' in error.response.data && error.response.data.errors) {
                        for (let field in error.response.data.errors) {
                            if (error.response.data.errors.hasOwnProperty(field)) {
                                this.$toast.error({
                                    title:   'NAPAKA!',
                                    message: error.response.data.errors[field][0],
                                    timeOut: 10000
                                });
                            }
                        }
                    }
                });
        },

        setSelectedSourceId(event) {
            this.$set(this.moreParams, 'source_id', event.id);
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Contacts/ScheduledDeletions.vue